import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/preferred-locations/profile/loading';

export const Route = createFileRoute('/_private/settings/preferred-locations/$id')({
  pendingComponent: Loading,
});
